import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Types
import Reducers from 'types/Reducers';

interface IState {
  snackbarMessage: string | null;
  appSyncEventsConfig: any;
};

const initialState:IState = {
  snackbarMessage: null,
  appSyncEventsConfig: null
};

const slice = createSlice({
  name: Reducers.UI,
  initialState,
  reducers: {
    setSnackbarMessage: (state, action:PayloadAction<string | null>) => {
      state.snackbarMessage = action.payload;
    },
    setAppSyncEventsConfig: (state, action:PayloadAction<any>) => {
      state.appSyncEventsConfig = action.payload;
    }
  },
  extraReducers(builder) {
    
  }
});

export const { setSnackbarMessage, setAppSyncEventsConfig } = slice.actions;

export default slice.reducer;
